import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Entities } from "src/app/core/models/globals";
import { NavigationService } from "src/app/core/services/navigation.service";

@Component({
  selector: "app-application-left-panel",
  templateUrl: "./application-left-panel.component.html",
  styleUrls: ["./application-left-panel.component.scss"],
})
export class ApplicationLeftPanelComponent implements OnInit {
  properties = [
    {
      name: "Applications",
      routerLink: "Applications",
      spanClass: "bi bi-disc",
    },
    {
      name: "Logs",
      routerLink: "Logs",
      spanClass: "bi bi-body-text",
    },
  ];

  selectedIndex: number;

  constructor(
    private navService: NavigationService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.navService.sendParentData(Entities.Applications);
    this.navService.index.subscribe((x) => {
      this.selectedIndex = x;
    });
  }

  sendData(index: number, property) {
    if (this.selectedIndex != index) {
      this.selectedIndex = index;
      this.navService.sendParentData(property.name);
      this.navService.sendLeftPanelIndex(index);
      this.router.navigate([property.routerLink], { relativeTo: this.route })
      this.navService.selectedLogType = "application";
    }
  }
}
